import RadioSystem from './RadioSystem';
import './RadioSystem.scss';

export default RadioSystem;
